import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  IUserAvailability,
  TUserAvailabilitySlotOption,
  TUserAvailabilitySlotOptionsData,
  TUserAvailabilitySlots,
} from '.';
import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';

export type TGetUserAvailabilitySlots = {
  userId: string;
  sectionId: string;
  date: string;
  duration: number;
};

type TGetTutorAvailabilitySlots = {
  curriculum: string;
  subject: string;
  grade: string;
  date: string;
};

type TGetTutorAvailabilitySlotsForProfile = {
  tutor: string;
  date?: string;
  duration?: number;
  type?: 'class' | 'trial';
};

export type TUpdateUserAvailabilityAsUser = {
  userId: string;
  slots: TUserAvailabilitySlots;
};

const apiDataProvider = new APIDataProvider();

export const getUserAvialabilityDataByUserIdAsUser = createAsyncThunk(
  '/user-availability/getOneByUserId',
  async (userId: string) => {
    const path = `${ApiPaths.userAvailability}/${userId}`;
    const response = await apiDataProvider.get<TApiResponse<IUserAvailability>>(
      path
    );

    return response.data;
  }
);

export const getTutorAvialabilityDataByUserIdForProfile = createAsyncThunk(
  '/user-availability/tutor/getOneByUserId',
  async (userId: string) => {
    const path = `${ApiPaths.userAvailability}/tutor/${userId}`;
    const response = await apiDataProvider.get<TApiResponse<IUserAvailability>>(
      path
    );

    return response.data;
  }
);

export const updateUserAvialabilityAsUser = createAsyncThunk(
  '/user-availability/update',
  async ({ userId, ...data }: TUpdateUserAvailabilityAsUser) => {
    const path = `${ApiPaths.userAvailability}/${userId}`;
    const response = await apiDataProvider.put<TApiResponse<IUserAvailability>>(
      path,
      data
    );

    return response.data;
  }
);

export const getUserAvailabilitySlotOptionsDataAsUser = createAsyncThunk(
  '/user-availability/slots/userId',
  async (data: TGetUserAvailabilitySlots) => {
    const path = `${ApiPaths.userAvailability}/slots/${data.userId}?date=${data.date}&userId=${data.userId}&sectionId=${data.sectionId}&duration=${data.duration}`;

    const response = await apiDataProvider.get<
      TApiResponse<TUserAvailabilitySlotOptionsData>
    >(path);

    return response.data;
  }
);

export const getUserAvailabilitySlotsForTrial = createAsyncThunk(
  '/user-availability/slots/trial',
  async (data: TGetTutorAvailabilitySlots) => {
    const path = `${ApiPaths.userAvailability}/slots/trial`;

    const response = await apiDataProvider.post<
      TApiResponse<TUserAvailabilitySlotOption[]>
    >(path, data);

    return response.data;
  }
);

export const getTutorAvailabilitySlotsForProfile = createAsyncThunk(
  '/user-availability/slots/tutor',
  async (data: TGetTutorAvailabilitySlotsForProfile) => {
    const path = `${ApiPaths.userAvailability}/slots/tutor`;

    const response = await apiDataProvider.post<
      TApiResponse<TUserAvailabilitySlotOption[]>
    >(path, data);

    return response.data;
  }
);
